import { render, staticRenderFns } from "./SyllabusIndex.vue?vue&type=template&id=1b02a958"
import script from "./SyllabusIndex.js?vue&type=script&lang=js&external"
export * from "./SyllabusIndex.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports